import NavBarT1 from "./assets/navbar/NavBarT1";
import Home from "./pages/Home";

function App() {
  return (
    <div className="App">
      <NavBarT1 />
      <Home />
    </div>
  );
}

export default App;
